import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActionType, FocusInputType, InteractionType, KeyValues10, KeyValues5, LocalService, PageKey, RelationShipRole, Status } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';

@Component({
  selector: 'app-business-payments',
  templateUrl: './business-payments.component.html',
  styleUrls: ['./business-payments.component.scss']
})
export class BusinessPaymentsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["biz_payments"]; newData: KeyValues5; items: KeyValues10[];
  @Input() isViewMode = false; @Input() businessId = ''; @Input() businessPaymentType: InteractionType = InteractionType.None;
  userId = ''; interactionType = InteractionType.User; ctryCode = ''; isQrCode = false;
  RelationShipRole = RelationShipRole;

  elementIds: any = {
    txt_detail: 'txt_detail',
    txt_title: 'txt_title'
  };

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private sellerManagementService: SellerManagementService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (!this.isViewMode) {
      this.route.params.subscribe(routeParams => {
        this.interactionType = routeParams.interactionType;
        this.businessId = routeParams.businessId;
        if (this.interactionType == InteractionType.Business)
          this.configurationManagementService.ensurePageActions(PageKey.PaymentTypes, this.businessId);
        else if (this.interactionType == InteractionType.ServiceProvider)
          this.configurationManagementService.ensurePageActions(PageKey.PaymentTypesServiceProvider);
        if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
          this.localService.redirectToSeller();
        } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
          this.localService.onDirectToServiceProviderCreation();
        } else {
          this.localService.saveUrl();
          this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
          this.userId = routeParams.userId;
          this.interactionType = routeParams.interactionType;
          this.ctryCode = routeParams.ctryCode;
          this.businessPaymentType = this.interactionType == InteractionType.Business ? InteractionType.Business : InteractionType.ServiceProvider;
          this.onLoad();
        }
      });
    } else {
      this.onLoad();
    }
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.newData = { key: '', v1: this.businessId, v2: '', v3: '', v4: '', v5: '' } as KeyValues5;
      setTimeout(() => { this.onChange(1) }, 100);
      this.sellerManagementService.getPaymentDetails(this.businessId, !this.isViewMode, this.businessPaymentType).subscribe(result => {
        this.items = result;
      });
    }
  }

  onSave(data: KeyValues5, actionType: ActionType) {
    data.v1 = this.businessId;
    data.v4 = actionType.toString();
    data.v5 = this.isQrCode ? '1' : '0';
    this.sellerManagementService.savePaymentDetail(data).subscribe(result => {
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onChange(index) {
    switch (index) {
      case 1: {
        if (this.newData.v2 == '')
          this.localService.onFocusNextInput(this.elementIds.txt_title, FocusInputType.TextBox);
        else if (this.newData.v3 == '')
          this.localService.onFocusNextInput(this.elementIds.txt_detail, FocusInputType.TextBox);
      } break;
    }
  }
}
